exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-thumbnail {\n  margin-left: 2em;\n  height: 8em;\n  cursor: pointer; }\n\n.full-size-image-container {\n  position: fixed;\n  z-index: 2;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n  .full-size-image-container .full-size-image {\n    cursor: pointer;\n    max-width: 90%;\n    max-height: 90%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/AreaImageComponent/areaImage.component.scss
// module id = ./src/app/common/components/AreaImageComponent/areaImage.component.scss
// module chunks = main